<template>
  <el-dialog
    custom-class="promo-dialog"
    :visible.sync="showPromo"
    :show-close="false"
    width="720px"
    center
    append-to-body
  >
    <div v-if="promoHtml" class="promo-content-wrapper">
      <div class="promo-html-container" v-html="promoHtml"></div>
      <i class="el-icon-close promo-close-btn" @click="showPromo = false"></i>
    </div>
  </el-dialog>
</template>

<script>
import { homeAd } from "@/api/display.js";

export default {
  name: "PromoDialog",
  data() {
    return {
      showPromo: false,
      promoHtml: "",
    };
  },
  methods: {
    async getHomeAd() {
      try {
        const { data } = await homeAd();
        if (data && data.htmlText) {
          this.promoHtml = data.htmlText;
          this.showPromo = true;
        }
      } catch (error) {
        // Silently fail
      }
    },
  },
  mounted() {
    this.getHomeAd();
  },
};
</script>

<style lang="scss">
.promo-dialog {
  margin-top: 12vh !important;
  background: #fff !important;
  width: min(94vw, 720px) !important;
  max-width: 94vw !important;
  position: relative !important;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);

  .el-dialog__header {
    padding: 0 !important;
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
    overflow: hidden !important;
  }

  .promo-content-wrapper {
    position: relative;
  }

  .promo-html-container {
    max-height: 80vh;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    > * {
      min-width: 0 !important;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #c3c3c3;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }

  .promo-close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 30px;
    color: #b6a9f2;
    cursor: pointer;
    z-index: 1001;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
